import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSliderSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9.167 4.667H2.5m6.667 0a2.166 2.166 0 1 1 4.332-.001 2.166 2.166 0 0 1-4.332 0m4.333 6.666H8.167m0 0a2.166 2.166 0 1 1-4.334 0m4.334 0a2.166 2.166 0 1 0-4.334 0m0 0H2.5"
	})
});
export default SvgSliderSettings;
